// src/lib/auth.ts
export type Permission = string;

function getStorage(): Storage {
  const where = localStorage.getItem("authStorage");
  return where === "local" ? localStorage : sessionStorage;
}

export function getToken(): string | null {
  return getStorage().getItem("accessToken");
}

export function getUser() {
  const raw = getStorage().getItem("userData");
  return raw ? JSON.parse(raw) : null;
}

export function getPermissions(): Permission[] {
  const raw = getStorage().getItem("allPermission");
  try {
    return raw ? (JSON.parse(raw) as Permission[]) : [];
  } catch {
    return [];
  }
}

export function hasPerm(perm: Permission): boolean {
  return getPermissions().includes(perm);
}

export function hasAnyPerm(perms: Permission[]): boolean {
  const set = new Set(getPermissions());
  return perms.some(p => set.has(p));
}

export function hasAllPerm(perms: Permission[]): boolean {
  const set = new Set(getPermissions());
  return perms.every(p => set.has(p));
}



export function logout() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("userData");
  localStorage.removeItem("allPermission");

  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("userData");
  sessionStorage.removeItem("allPermission");

  window.location.href = "/login";
}
